/* src/app/company-setting/company-setting-presenter/company-setting-presenter.component.scss */
body#themeTag :host ::ng-deep .p-datatable-row.p-selectable-row {
  height: 3em !important;
}
body#themeTag :host ::ng-deep table.p-datatable-table tbody.p-datatable-tbody > tr > td.medium-cell {
  align-self: center;
}
body#themeTag :host ::ng-deep table.p-datatable-table tbody.p-datatable-tbody > tr > td.large-cell {
  align-self: center;
}
body#themeTag :host ::ng-deep .sticky-table-container .p-datatable .p-datatable-tbody > tr.p-selectable-row > td.p-datatable-cell {
  height: 3em !important;
}
body#themeTag :host ::ng-deep .p-inputtext {
  height: 2.5em !important;
  padding: 0 0.5rem 0 0.5rem !important;
}
body#themeTag :host ::ng-deep .p-dropdown-label {
  margin-top: 0.2em;
}
body#themeTag :host ::ng-deep .p-dropdown.p-component {
  height: 2.5em !important;
  margin-top: 0.15em !important;
}
body#themeTag :host ::ng-deep .p-editable-column .p-inputtext.p-component {
  width: 100%;
  margin-top: 0.15em !important;
}
body#themeTag :host ::ng-deep .p-checkbox {
  margin-top: 0.45em !important;
}
body#themeTag :host ::ng-deep .tabulator-header-filter {
  height: 2.1em;
}
body#themeTag :host ::ng-deep .p-header-cell {
  height: 2.1rem !important;
}
body#themeTag :host ::ng-deep .sticky-table-container .p-datatable .p-datatable-thead > tr:not(:first-child) > th {
  padding: 0 !important;
}
body#themeTag :host ::ng-deep .p-editable-column {
  margin-top: -1px !important;
}
/*# sourceMappingURL=company-setting-presenter.component.css.map */
